import { mergeAttributes, Node } from '@tiptap/core'
import { v4 as uuidv4 } from 'uuid'

export interface EmbedOptions {
  inline: boolean
}

export type EmbedAttributes = {
  'data-content'?: string
  'data-margin-top'?: number
  'data-margin-bottom'?: number
  placeHolderText: string
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    embed: {
      setEmbed: (options: EmbedAttributes) => ReturnType
    }
  }
}

export const Embed = Node.create<EmbedOptions>({
  name: 'embed',

  addOptions() {
    return {
      inline: false,
    }
  },

  inline() {
    return this.options.inline
  },

  group() {
    return this.options.inline ? 'inline' : 'block'
  },

  draggable: true,

  addAttributes() {
    return {
      'data-code-embed-container': {
        default: '',
      },
      'data-content': {
        default: null,
      },
      'data-margin-top': {
        default: null,
      },
      'data-margin-bottom': {
        default: null,
      },
      placeHolderText: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-code-embed-container]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const embedId = uuidv4()
    const placeholderStyles =
      'border-2 border-rounded text-center text-curious-blue-500 border-blue-300 capitalize'

    HTMLAttributes.style = ''
    if (HTMLAttributes['data-margin-top']) {
      HTMLAttributes.style += `margin-top: ${HTMLAttributes['data-margin-top']}px; `
    }
    if (HTMLAttributes['data-margin-bottom']) {
      HTMLAttributes.style += `margin-bottom: ${HTMLAttributes['data-margin-bottom']}px; `
    }
    return [
      'div',
      mergeAttributes(
        {
          id: embedId,
        },
        HTMLAttributes
      ),
      [
        'div',
        mergeAttributes({
          'data-code-embed-placeholder': 1,
          class: placeholderStyles,
        }),
        HTMLAttributes.placeHolderText,
      ],
    ]
  },

  addCommands() {
    return {
      setEmbed:
        options =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
    }
  },
})
